import React, {useEffect, useState, useRef} from 'react'
import "./style.scss"
import Input from "../Input"
 
const Index = ({
    value,
    onChange,
    searchable=false,
    options=[],
    label,
    setIsDisabled = () => {},
    className = '',
    optionType='',
    placeholder = 'Search protein',
}) => {
const dropdownRef = useRef(null)
const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const [search, setSearch] = useState('')
const [tempOptions, setTempOptions] = useState([])

useEffect(() => {
    if(searchable && search){
        const filteredOptions = options.filter((option) => {
            if (optionType === 'role') {
                return option.name.toLowerCase().includes(search.toLowerCase())
            } else {
              return option.toLowerCase().includes(search.toLowerCase())
            }
        })
        setTempOptions(filteredOptions)
    }else{
        setTempOptions(options)
    }

},[search, searchable, options])

useEffect(() => {
  const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsDropdownOpen(false)
      }
  };

  document.addEventListener('mousedown', handleClickOutside);

  return () => {
      document.removeEventListener('mousedown', handleClickOutside);
  };

}, []);



  return (
    <div style={{position:'relative'}} className='protein-dropdown' ref={dropdownRef}>
    <div className={`selected-protein ${className}`} onClick={() => {
      setIsDropdownOpen(!isDropdownOpen)
      setIsDisabled(true)
    }}> 
     {/* {searchable && value ? <span className='protein-chip'>{value}
      <i className='fas fa-times' style={{marginLeft:'15px'}} onClick={() => onChange('')}></i>
      </span>
      : */}
      <span>{value ? optionType === 'role' ? value.name : value : label}</span>
      {/* } */}
      <span style={{color:'var(--primary-color)'}}  onClick={() => {
        setIsDropdownOpen(!isDropdownOpen)
        setIsDisabled(true)
      }}>{isDropdownOpen ? <i className='fal fa-angle-up'></i> : <i className='fal fa-angle-down'></i>}</span>
    </div>
  {isDropdownOpen &&  <div className="dropdown-container">
    {searchable &&  <Input type="text" search style={{ height: '40px', paddingLeft: '30px' }} placeholder={placeholder} value={search} onChange={(e) => setSearch(e.target.value)} /> }
    {tempOptions && tempOptions?.map((item, index) => {
      return (
        <div key={index} className="dropdown-item" style={{color: optionType === 'role' ? item?.id === value?.id ? 'var(--primary-color)' : '' : item === value ? 'var(--primary-color)' : ''}}  onClick={() => {
            onChange(item)
            setIsDropdownOpen(false)
            setIsDisabled(false)
            setSearch('')
            }}>
          <span>{optionType === 'role' ? item.name : item}</span>
        </div>
      )
    })}
    </div>
}
    </div>
  )
}

export default Index